import React from 'react';
import { InstagramIcon, YoutubeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TikTokIcon } from './icons/TikTokIcon';
export function Footer() {
  return <footer className="w-full bg-neutral-900 px-4 pb-3 pt-5 text-neutral-300 sm:px-6" data-id="element-207" data-mp="32o4d0g3lai96">
      <div className="mx-auto flex max-w-[1300px] flex-col gap-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-208" data-mp="36pfu1x8edv5r">
        <div className="flex items-center gap-3" data-id="element-209" data-mp="3ueijvsd6qubc">
          <img src="https://cdn.magicpatterns.com/uploads/dVxge7E5WrZsG2Xk4nm9RJ/image.png" alt="Logo der Sales Academy" className="h-10 w-10 rounded-full object-contain" data-id="element-210" data-mp="3uftmhouw9w0v" />
          <span className="text-sm font-semibold uppercase tracking-widest text-white" data-id="element-211" data-mp="3lgooqkr5q6pr">
            Hot Sales Girls
          </span>
        </div>

        <nav aria-label="Footer" className="grid grid-cols-2 gap-x-6 gap-y-2 text-center text-sm lg:flex lg:items-center lg:gap-8" data-id="element-212" data-mp="29y5hq2ysxow2">
          <Link to="/ablauf" className="hover:text-white" data-id="element-213" data-mp="3l9k5rctv1nda">
            Ablauf der Academy
          </Link>
          <Link to="/about-me" className="hover:text-white" data-id="element-214" data-mp="3gapc1fucueee">
            About Me
          </Link>
          <Link to="/impressum" className="hover:text-white" data-id="element-215" data-mp="3v7gexz38m88r">
            Impressum
          </Link>
          <Link to="/datenschutz" className="hover:text-white" data-id="element-216" data-mp="3q8wrfu8zwoea">
            Datenschutz
          </Link>
        </nav>

        <div className="flex items-center gap-3" data-id="element-217" data-mp="828oa9xiabb9">
          <a href="https://www.instagram.com/tina_xla/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700" data-id="element-218" data-mp="80xhs2coepgg">
            <InstagramIcon className="h-5 w-5" aria-hidden="true" data-id="element-219" data-mp="cvtn246xb9bi" />
          </a>
          <a href="https://www.tiktok.com/@tina_xla?_t=ZN-8tHLLH6ugD8&_r=1" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700" data-id="element-220" data-mp="qu1e5vha3ger">
            <TikTokIcon className="h-5 w-5" data-id="element-221" data-mp="ys3f8e5fmz01" />
          </a>
          <a href="https://www.youtube.com/@tina_xla" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700" data-id="element-222" data-mp="13s9a037011mc">
            <YoutubeIcon className="h-5 w-5" aria-hidden="true" data-id="element-223" data-mp="1hjw7g6cogg6p" />
          </a>

        </div>
      </div>

      <p className="mx-auto mt-3 max-w-[1300px] text-center text-xs text-neutral-500" data-id="element-224" data-mp="1mkto2ei1h263">
        © 2026 Mermaid Beauty Aesthetics FZCO, Die dargestellten Inhalte dienen ausschließlich zu
        Marketing- und Informationszwecken. Maßgeblich sind ausschließlich die jeweils gültigen AGB
      </p>
    </footer>;
}